/** Shared wording for the opt-in create row used by our creatable selects. */
export const formatCreateOptionLabel = (inputValue: string) => `Add "${inputValue}"`;
